<section class="contact-section">
  <div class="contact-content">
    <div class="text-center">
      <h2>Kontaktieren Sie uns</h2>
      <p class="subtitle">Haben Sie Fragen? Wir sind für Sie da!</p>
    </div>

    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
      <div class="form-row">
        <div class="form-field">
          <label>Vorname<span class="required">*</span></label>
          <div class="input-wrapper">
            <mat-icon class="input-icon">person</mat-icon>
            <input matInput formControlName="firstName" placeholder="Ihr Vorname" required>
          </div>
          <mat-error *ngIf="contactForm.get('firstName')?.invalid && contactForm.get('firstName')?.touched">
            {{ getErrorMessage('firstName') }}
          </mat-error>
        </div>

        <div class="form-field">
          <label>Nachname<span class="required">*</span></label>
          <div class="input-wrapper">
            <mat-icon class="input-icon">person</mat-icon>
            <input matInput formControlName="lastName" placeholder="Ihr Nachname" required>
          </div>
          <mat-error *ngIf="contactForm.get('lastName')?.invalid && contactForm.get('lastName')?.touched">
            {{ getErrorMessage('lastName') }}
          </mat-error>
        </div>
      </div>

      <div class="form-field">
        <label>E-Mail<span class="required">*</span></label>
        <div class="input-wrapper">
          <mat-icon class="input-icon">mail</mat-icon>
          <input matInput type="email" formControlName="email" placeholder="ihre.email@beispiel.de" required>
        </div>
        <mat-error *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched">
          {{ getErrorMessage('email') }}
        </mat-error>
      </div>

      <div class="form-field">
        <label>Ihre Nachricht<span class="required">*</span></label>
        <textarea matInput rows="5" formControlName="message" 
                  placeholder="Wie können wir Ihnen helfen?" required></textarea>
        <mat-error *ngIf="contactForm.get('message')?.invalid && contactForm.get('message')?.touched">
          {{ getErrorMessage('message') }}
        </mat-error>
      </div>

      <div class="privacy-policy">
        <mat-checkbox formControlName="privacyPolicy" required 
                     class="custom-checkbox">
          <span class="checkbox-label">
            Ich stimme der Verarbeitung meiner Daten gemäß der 
            <a routerLink="/datenschutz" class="privacy-link">Datenschutzerklärung</a> zu
          </span>
        </mat-checkbox>
        <mat-error *ngIf="contactForm.get('privacyPolicy')?.invalid && contactForm.get('privacyPolicy')?.touched">
          Bitte stimmen Sie der Datenschutzerklärung zu
        </mat-error>
      </div>

      <button mat-flat-button type="submit" 
              [disabled]="contactForm.invalid || isSubmitting"
              class="submit-button">
        <div class="button-content">
          <mat-icon *ngIf="!isSubmitting">send</mat-icon>
          <span *ngIf="!isSubmitting">Nachricht senden</span>
          <div *ngIf="isSubmitting" class="spinner-container">
            <mat-spinner diameter="24"></mat-spinner>
            <span>Wird gesendet...</span>
          </div>
        </div>
      </button>

      <div class="alert success" *ngIf="submitSuccess">
        Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns in Kürze bei Ihnen melden.
      </div>

      <div class="alert error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
    </form>
  </div>
</section> 